"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.661 3a.7.7 0 0 1 .7.7v.589h7.261c1.235 0 1.876 1.472 1.036 2.376L13.11 8.33l-.003.004-.001.006v.005l.004.004 1.547 1.665c.84.905.199 2.376-1.036 2.376h-7.26v3.91a.7.7 0 1 1-1.4 0V3.7a.7.7 0 0 1 .7-.7m.7 7.99h7.269l.005-.008.002-.009-.005-.006-1.547-1.665a1.414 1.414 0 0 1 0-1.925l1.547-1.665.005-.006-.002-.009-.005-.008H6.362z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=FlagIcon20.js.map